module.exports = __webpack_public_path__ + "img/Fototeam.9622941d.png";